"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FutureReadyAvIntegration() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section id="future-ready-av-integration" className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 !bg-[url(https://suitable-martin.10web.cloud/wp-content/uploads/2026/03/20240119_154145833_iOS-scaled.jpg)] bg-cover bg-center bg-no-repeat !text-[hsl(210,11%,71%)] !opacity-[0.5]" />
        {}
        
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 md:px-6 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="max-w-4xl mx-auto space-y-6">
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold tracking-tighter text-white drop-shadow-sm">
            FUTURE-READY <br className="hidden sm:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-white/70">AUDIOVISUAL SOLUTIONS&nbsp;&nbsp;</span>
          </h1>
          
          <p className="max-w-2xl mx-auto drop-shadow-sm !bg-transparent !text-[hsl(210,14%,83%)] !text-lg !font-semibold">Connecting People Through Technology</p>

          <div className="pt-8 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8">
            <Button variant="link" size="lg" asChild className="text-muted-foreground hover:text-white text-base sm:text-lg order-2 sm:order-1 transition-colors">
              
            </Button>

            <Button size="lg" asChild className="bg-primary text-primary-foreground hover:bg-primary/90 h-14 px-8 text-lg font-semibold shadow-lg shadow-primary/20 order-1 sm:order-2 group">
              
            </Button>

            <Button variant="link" size="lg" asChild className="text-muted-foreground hover:text-white text-base sm:text-lg order-3 transition-colors">
              
            </Button>
          </div>
        </div>
      </div>
    </section>;
}